import { useState } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import RadioDot from "../../components/common/RadioDot";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import { useNavigate } from "react-router-dom";
import SessionStorageHelper from "../../utils/sessionStorageHelper";
import "../../styles/globals.css";

const Genderpage = () => {
  const [selected, setSelected] = useState<string>("");
  const navigate = useNavigate();

  const handleNext = () => {
    if (selected) {
      SessionStorageHelper.saveField("gender", selected.toLowerCase());
      navigate("/glucera" + GluceraNavigationRoutes.RACE_PAGE);
    }
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header with Progress */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          {/* <button
            onClick={handleBack}
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-muted/80 transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button> */}
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-sm text-muted-foreground">
            Assessment 1 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-4 py-2 sm:px-6 sm:py-4">
          <div className="mb-4 space-y-1 sm:mb-6 sm:space-y-2">
            <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
              What Is Your Gender?
            </h1>
            <p className="text-xs text-muted-foreground sm:text-sm">
              Gender Affects Diabetes Management
            </p>
          </div>

          {/* Options - Responsive spacing for content height */}
          <div className="mb-6 space-y-3">
            {["Male", "Female", "Other"].map(option => (
              <Card
                key={option}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selected === option
                    ? "border border-primary bg-primary/5"
                    : "border border-border hover:border-primary/50"
                }`}
                onClick={() => setSelected(option)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-lg font-semibold">{option}</span>
                  <RadioDot selected={selected === option} />
                </div>
              </Card>
            ))}
          </div>

          {/* Button Container - Fixed position */}
          <div className="mt-auto">
            <Button
              onClick={handleNext}
              disabled={!selected}
              className={gluceraAssessmentCta}
            >
              {selected ? "Next" : "Select Gender"}
            </Button>
          </div>
        </div>

        {/* Safe area padding for mobile */}
        <div className="pb-safe p-4 sm:pb-6" />
      </div>
    </div>
  );
};

export default Genderpage;
